const LEADERSHIP_ROLES = new Set([
  "owner",
  "system_owner",
  "partner",
  "director_of_operations"
]);

export function normalizeRole(role) {
  return String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function isLeadership(user) {
  return LEADERSHIP_ROLES.has(normalizeRole(user?.role));
}
